import { withInstall } from '../../utils/install';
import Ellipsis from './index.vue';

export const IvueEllipsis = withInstall(Ellipsis);
export default IvueEllipsis;

export * from './index.vue';
